// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2Hh78","container":"styles_container__3RG3L","title":"styles_title__lBqzy","wrapper":"styles_wrapper__368Z1","answer":"styles_answer__2zCWn"};